/**
 * Звук: где он звучит и что о нём едет по сети.
 *
 * ГЛАВНОЕ РЕШЕНИЕ КОНТУРА. Пад в правой колонке - это КОМАНДА ОВЕРЛЕЮ. Звук
 * звучит там, где его слышит эфир, а не в браузере стримера: браузер стримера
 * в OBS не захватывается, и «нажал - у себя слышу, в записи тишина» - это
 * отказ, который обнаруживает зритель, а не стример.
 *
 * Прослушивание в библиотеке настроек - наоборот, ЛОКАЛЬНОЕ: там человек
 * выбирает файл и не должен ради этого пускать звук в эфир. Разница названа
 * стримеру словами в самом интерфейсе, а не подразумевается.
 *
 * ФАЙЛ ПО СЕТИ НЕ ЕДЕТ. Команда несёт адрес, оверлей забирает файл сам и
 * только когда он понадобился: иначе звуки попали бы в первую загрузку
 * оболочки и в её бюджет (docs/ARCHITECTURE.md, 3.4).
 */
/**
 * Каналы микшера. Объявлены ВСЕ СЕМЬ, показываются только те, у которых есть
 * источник: пустой ползунок обещает управление тем, чего нет.
 *
 * `tts`, `alerts` и `giftFx` приезжают вместе со своими элементами - единица 6
 * (docs/ROADMAP.md). До тех пор их в интерфейсе нет, а в схеме они есть:
 * громкость, сохранённая до появления источника, не должна теряться.
 */
export const SOUND_CHANNELS = [
    'master',
    'pads',
    'gameSounds',
    'gameMusic',
    'tts',
    'alerts',
    'giftFx',
];
/**
 * Пределы звукового контура - ЧИСЛАМИ В ОДНОМ МЕСТЕ.
 *
 * Они настраиваемые: объявлены здесь, показываются человеку в интерфейсе до
 * того, как он в них упрётся, и меняются правкой одной строки. Предел,
 * выясняемый отказом, - это предел, о котором не сказали.
 */
export const SOUND_LIMITS = {
    /** Ячеек на сетке падов: от, до, по умолчанию. */
    padsMin: 4,
    padsMax: 48,
    padsDefault: 12,
    /** Своих звуков на аккаунт. */
    perAccount: 50,
    /** Вес одного файла. */
    maxBytes: 5 * 1024 * 1024,
    /** Шаг ползунка громкости. */
    volumeStep: 0.05,
    /** Треков на аккаунт и вес одного трека: музыка длиннее пада на порядок. */
    musicPerAccount: 30,
    musicMaxBytes: 20 * 1024 * 1024,
};
/** Что принимается на загрузку. Проверяется по содержимому, а не по имени. */
export const SOUND_MIME = ['audio/mpeg', 'audio/ogg', 'audio/wav'];
/** Заводской микшер: всё на трёх четвертях и ничего не отключено. */
export function defaultMixer() {
    return Object.fromEntries(SOUND_CHANNELS.map((channel) => [channel, { volume: 0.75, muted: false }]));
}
//# sourceMappingURL=sound.js.map